define('AwaLabs.UnitsOfMeasure', [
    'UnitOfMeasure.ProductViews.Price.View',
    'UnitOfMeasure.ProductDetails.Full.View',
    'UnitOfMeasure.ProductDetails.QuickView.View'
], function AwaLabsUnitsOfMeasure() {});
